import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, Platform } from '@ionic/angular';
import { AppState } from '../app.service';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';

@Component({
  selector: 'app-media-types-screen',
  templateUrl: './media-types-screen.component.html',
  styleUrls: ['./media-types-screen.component.scss'],
})
export class MediaTypesScreenComponent implements OnInit, AfterViewInit {
  @Input() type;
  @Input() screenData;
  isInstepViewableDoc;
  safePdfUrl
  isMobile;
  pdfSrc;
  webPdfLik
  constructor(private sanitizer: DomSanitizer, private modalController: ModalController,
    private appState: AppState,private file: File,private transfer: FileTransfer,
    public platform: Platform) { }

  ngOnInit() {
    this.isMobile= this.appState.get('isMobile')
  }

  ngAfterViewInit(): void {
    let url = this.screenData?.media?.url;
    this.isInstepViewableDoc = this.getExtension(url) === 'pdf';
    // if(url.toLowerCase().endsWith('.pptx')|| url.toLowerCase().endsWith('.ppt')) {
    //   url = 'https://docs.google.com/viewer?url=' + url;
    // }
    if (this.isMobile && !this.platform.is('mobileweb')) {
      this.viewDocument(url);
    }
    this.webPdfLik = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.webPdfLik = this.webPdfLik.changingThisBreaksApplicationSecurity;

    if ((this.isMobile && this.platform.is('mobileweb')) || !this.isMobile) {
      this.safePdfUrl = this.webPdfLik;
    }
    // this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url+'#toolbar=0&navpanes=0&scrollbar=0');
  }

  getExtension(url?: string): string {
    if (!url) return '';

    try {
      const pathname = new URL(url).pathname;
      return pathname.split('.').pop()?.toLowerCase() ?? '';
    } catch {
      return '';
    }
  }
   async viewDocument (url) {
     if(url.match('.pdf')) {
      const transfer = this.transfer.create();
      let path = null;
      const name = url.substr(url.lastIndexOf("/") + 1);
      const fileName = name.split("?")[0];

      if (this.platform.is("ios")) {
        path = this.file.documentsDirectory;
      } else {
        path = this.file.dataDirectory;
      }

      transfer
        .download(url, path + fileName)
        .then((entry) => {
          this.fileToBase64(fileName, path.replace("/" + fileName, ""));
        })
        .catch((e) => {
          console.log("failed error", e);
        });
    }
   
  }

  async  fileToBase64(filename, filepath){
    let base64String =  await this.file.readAsDataURL(filepath, filename);
    this.pdfSrc=base64String.slice(28);
    this.Base64toArrayBuffer() 
  }

  Base64toArrayBuffer(){
    var binary_string = window.atob(this.pdfSrc);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    this.safePdfUrl= bytes.buffer;
  }
  close() {
     this.modalController.dismiss()
  }

}
